import { registerPlugin } from '@capacitor/core';
const LiveMicrophoneData = registerPlugin('LiveMicrophoneData', {
    web: () => import('./web').then((m) => new m.LiveMicrophoneDataWeb()),
});
export * from './definitions';
export { LiveMicrophoneData };
//# sourceMappingURL=index.js.map